var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"calculator__tab"},[_c('CalculatorForm',{attrs:{"type":"mortgage"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }